import { render } from "./langButton.vue?vue&type=template&id=29bbf29b&scoped=true"
import script from "./langButton.vue?vue&type=script&lang=js"
export * from "./langButton.vue?vue&type=script&lang=js"

import "./langButton.vue?vue&type=style&index=0&id=29bbf29b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-29bbf29b"

export default script